import { Box, Typography } from "@mui/material";
import Chart from "react-apexcharts";
import useColors from "../../../../../api/hooks/useColors";
import TrendIndicator from "../../TrendIndicator";
export default function InfrastructurePillarBox({
  pillar,
  coverage,
  domainsCount,
  chartOptions,
  trendData,
}) {
  const colors = useColors();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        margin: "8px 0px 8px 0px",
        overflow: "hidden",
        cursor: "pointer",
        transition: "transform 0.4s ease-in-out",
        "&:hover": {
          transform: "scale(1.04)",
        },
      }}
    >
      {/* Upper Text - Pillar Name */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 1,
        }}
      >
        <Typography variant="subtitle2" sx={{ color: colors.text_secondary }}>
          {pillar}
        </Typography>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "10px",
          }}
        >
          {trendData && <TrendIndicator data={trendData} showPercent={true} />}
        </Box>
      </Box>

      {/* Chart */}
      {chartOptions?.series && (
        <Box sx={{ width: "200px", height: "90px" }}>
          <Chart
            options={chartOptions}
            series={chartOptions?.series}
            type="radialBar"
          />
        </Box>
      )}
    </Box>
  );
}
